/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowIncidentManagementCustomFieldsMapping {
    getFixupPrototypeFunction() { return ServiceNowIncidentManagementCustomFieldsMapping.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowIncidentManagementCustomFieldsMapping>): ServiceNowIncidentManagementCustomFieldsMapping {
        let obj = Object.assign(new ServiceNowIncidentManagementCustomFieldsMapping(), model);
        ServiceNowIncidentManagementCustomFieldsMapping.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowIncidentManagementCustomFieldsMapping>): ServiceNowIncidentManagementCustomFieldsMapping {
        if (!model) return null;
        return ServiceNowIncidentManagementCustomFieldsMapping.newInstance(<ServiceNowIncidentManagementCustomFieldsMapping> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowIncidentManagementCustomFieldsMapping) {
        if (!obj) return;

        models.ServiceNowIncidentManagementCustomFieldsMapping.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowIncidentManagementCustomFieldsMapping): boolean {
        Object.setPrototypeOf(obj, ServiceNowIncidentManagementCustomFieldsMapping.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.mapping_values) {
            for (let val of this.mapping_values) {
                models.ServiceNowIncidentManagementCustomFieldValueMapping.fixupPrototype(val);
            }
        }
    }

    /**
     * ServiceNow Incident Custom Field Name
     */
    field: string;

    /**
     * Direct value to use for custom field
     */
    value: string;

    /**
     * ServiceNow Incident Management Custom Field Mapping Keys
     */
    mapping_field: models.ServiceNowIncidentManagementCustomFieldValueMappingKey;

    /**
     * Value mapping for custom field
     */
    mapping_values: Array<models.ServiceNowIncidentManagementCustomFieldValueMapping>;

}
